import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    let form = document.getElementById("oauth-form-template");
    if (form) UI.showModal(form.innerHTML);
  }
}
